/* Keep optional media and theme-editor block selection in step with disclosure state. */
(()=>{
 function setup(scope){scope.querySelectorAll('.ag-about').forEach(root=>{
  if(root.dataset.disclosuresReady)return;
  root.dataset.disclosuresReady='true';
  root.querySelectorAll('[data-about-disclosure]').forEach(detail=>detail.addEventListener('toggle',()=>{
   if(!detail.open&&detail.querySelector('.about-film-stage iframe')){
    detail.querySelector('.about-film-stage iframe').remove();
    const play=detail.querySelector('[data-about-film-play]');if(play)play.hidden=false;
   }
  }));
  root.addEventListener('shopify:block:select',e=>{let detail=e.target.closest('details');while(detail&&root.contains(detail)){detail.open=true;detail=detail.parentElement.closest('details');}});
 });}
 setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
